import type { MovementType } from '../api';

// Paleta da SPEC 03 §3.1
const CONFIG: Record<MovementType, { label: string; className: string }> = {
  acquisition: { label: 'Aquisição', className: 'bg-blue-100 text-blue-800' },
  delivery: { label: 'Entrega', className: 'bg-green-100 text-green-800' },
  transfer: { label: 'Transferência', className: 'bg-orange-100 text-orange-800' },
  replacement: { label: 'Substituição', className: 'bg-indigo-100 text-indigo-800' },
  maintenance: { label: 'Manutenção', className: 'bg-purple-100 text-purple-800' },
  loan: { label: 'Empréstimo', className: 'bg-yellow-100 text-yellow-800' },
  return: { label: 'Devolução', className: 'bg-slate-100 text-slate-700' },
  retirement: { label: 'Baixa', className: 'bg-red-100 text-red-800' },
  location_change: { label: 'Mudança de localização', className: 'bg-teal-100 text-teal-800' },
};

interface Props {
  type: MovementType;
}

export function MovementTypeBadge({ type }: Props) {
  const cfg = CONFIG[type];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${cfg.className}`}
    >
      {cfg.label}
    </span>
  );
}

export const MOVEMENT_TYPE_LABELS = Object.fromEntries(
  (Object.entries(CONFIG) as Array<[MovementType, { label: string }]>).map(([k, v]) => [k, v.label]),
) as Record<MovementType, string>;
